import client from './requestclient';

const maintenanceRequests = {
    fetchServicesCategory: async () => {
        return await client({URL_PATH: `fetch-services-categories`, method: "GET"})
    },
    raiseMaintenaceRequest: async (body) => {
        return await client({URL_PATH: "raise-maintenace-request", method: "POST", body: body});
    },
    uploadRequestImages: async (formData) => {
        return await client({URL_PATH: "uploadpropertyimage", method: "POST", body: formData, bodyType: "FormData"});
    },
    searcheVendors: async (body) => {
        return await client({URL_PATH: "search-vendors-based-on-service-category-and-maintenance-location-with-maintenace-with-maintainace-id", method: "POST", body: body});
    },
    fetchMaintenanceById: async (id) => {
        return await client({URL_PATH: `get-maintainace-by-id/${id}`, method: "GET"})
    },
    assignRquestToVendor: async (body) => {
        return await client({URL_PATH: "assign-maintenance-to-vendor", method: "POST", body: body});
    },
   
}

export default maintenanceRequests;